import { render, staticRenderFns } from "./minimal-checkout.vue?vue&type=template&id=207f7d11&scoped=true"
import script from "./minimal-checkout.vue?vue&type=script&lang=js"
export * from "./minimal-checkout.vue?vue&type=script&lang=js"
import style0 from "./minimal-checkout.vue?vue&type=style&index=0&id=207f7d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f7d11",
  null
  
)

export default component.exports